import React from 'react';
import PhoneImage from '../Phone.png';
import { CONTACT_INFO } from '../constants';
import styles from '../App.module.less';

const ContactInfo = () => {
  return (
    <div className={`${styles.contactInfo} ${styles.cmeF20}`}>
        <img src={PhoneImage} alt="" />
        <div>
            <strong>Questions about our system of care?</strong> Just call us at{' '}
            <span>{CONTACT_INFO.phone}</span> (TTY: <span>{CONTACT_INFO.tty}</span>). 
            We're here for you {CONTACT_INFO.hours}.
        </div>
    </div>
  );
};

export default ContactInfo;